import { z } from 'zod';

// TODO: This data should be provided by HIP and not hardcoded here. Update when HIP connector is available.

// ! 👇 SAP TQ80_T — notification type. BEST (legacy, B-prefixed) and NICE (target, Z-prefixed)
export const NOTIFICATION_TYPES = [
  'BP', // BEST — Breakdown
  'BT', // BEST — Modification / TAE
  'BM', // BEST — Preventive maintenance
  'BQ', // BEST — Internal problem
  'ZP', // NICE — Breakdown
  'ZT', // NICE — Modification / TAE
  'ZM', // NICE — Preventive maintenance
  'ZQ', // NICE — Internal problem
] as const;
export const notificationTypeSchema = z.enum(NOTIFICATION_TYPES);
export type NotificationType = z.infer<typeof notificationTypeSchema>;

// ! 👇 SAP TJ02T — notification status
export const NOTIFICATION_STATUSES = [
  'I0068', // Outstanding
  'I0069', // Postponed
  'I0070', // In process
  'I0071', // Order assigned
  'I0072', // Completed
  'I0073', // Printed
  'I0076', // Deletion flag
  'I0158', // Outstanding task(s)
  'I0160', // Internal
  'I0161', // External
] as const;

export const notificationStatusSchema = z.enum(NOTIFICATION_STATUSES);
export type NotificationStatus = z.infer<typeof notificationStatusSchema>;

// ! 👇 SAP T356_T — priority type "ZA", 5 levels (not the 4-level U1-U4 scheme used by the old prototype)
export const maintenancePrioritySchema = z.union([
  z.literal(1), // Start < 24h
  z.literal(2), // Start < 7 days
  z.literal(3), // Start > 7 days
  z.literal(4), // Turnaround (arrêt)
  z.literal(5), // Maintenance plan > 7 days
]);

export type MaintenancePriority = z.infer<typeof maintenancePrioritySchema>;

// ! 👇 SAP V_QPCD_F4 — catalog "Q", code group "SYMPTOM2"
export const SYMPTOM_CODES = ['S010', 'S020', 'S040', 'S140', 'S175'] as const;
export const symptomCodeSchema = z.enum(SYMPTOM_CODES);
export type SymptomCode = z.infer<typeof symptomCodeSchema>;

// ! 👇 SAP T024I — planner group, scoped per maintenance planning plant; not a fixed enum.
export const plannerGroupSchema = z.object({
  plant: z.string().length(4), // IWERK
  code: z.string().max(3), // INGRP
  name: z.string(), // INNAM
});

export type PlannerGroup = z.infer<typeof plannerGroupSchema>;
